"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingButton = void 0; // @ts-ignore

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var react_1 = __importDefault(require("react"));

var lseds_1 = require("../../lseds");

var react_2 = require("react");

var foundation_1 = require("../../theme/foundation");

var core_1 = require("@emotion/core");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.FloatingButton = react_2.forwardRef(function FloatingButton(props, ref) {
  var type = props.type,
      variant = props.variant,
      label = props.label,
      icon = props.icon,
      size = props.size,
      rest = __rest(props, ["type", "variant", "label", "icon", "size"]);

  var setSize = function setSize(size) {
    switch (size) {
      case 'small':
        return {
          height: '1.5em',
          width: '1.5em',
          paddingLeft: '1em',
          paddingRight: '1em',
          padding: '0.5rem 1em',
          iconSize: '0.625em'
        };

      case 'medium':
        return {
          height: '2em',
          width: '2em',
          paddingLeft: '1em',
          paddingRight: '1em',
          padding: '0.75em 1.625em',
          iconSize: '0.875em'
        };

      case 'large':
        return {
          height: '2.5em',
          width: '2.5em',
          paddingLeft: '1em',
          paddingRight: '1em',
          padding: '1em 2em',
          iconSize: '1em'
        };

      case 'extra-large':
        return {
          height: '3em',
          width: '3em',
          paddingLeft: '1em',
          paddingRight: '1em',
          padding: '1.25em 2.375em',
          iconSize: '1.2755em'
        };

      default:
        return {
          height: 40,
          width: 40,
          paddingLeft: '1em',
          paddingRight: '1em',
          padding: '0.3rem 0.6rem',
          iconSize: '1.5em'
        };
    }
  };

  var defaultStyle = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 1.375em;\n\t\tcursor: pointer;\n\t\t", ";\n\t\t", ";\n\t\tpadding-left: ", ";\n\t\tpadding-right: ", ";\n\t\tpadding-top: 0.5rem;\n\t\tpadding-bottom: 0.5rem;\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t"], ["\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: 1.375em;\n\t\tcursor: pointer;\n\t\t", ";\n\t\t", ";\n\t\tpadding-left: ", ";\n\t\tpadding-right: ", ";\n\t\tpadding-top: 0.5rem;\n\t\tpadding-bottom: 0.5rem;\n\t\tbackground-color: ", ";\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: ", ";\n\t\t}\n\t"])), size && !label && "height: " + setSize(size).height + ";", size && !label && "width: " + setSize(size).width + ";", size && !label ? '0' : label && size ? setSize(size).paddingLeft : '1rem', size && !label ? '0' : label && size ? setSize(size).paddingRight : '1rem', foundation_1.colors.white, foundation_1.colors.primary.green, foundation_1.colors.actions.whiteStateHover);
  var iconStyle = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t", ";\n\t\tpadding-right: ", ";\n\t\tpadding-left: ", ";\n\t"], ["\n\t\t", ";\n\t\tpadding-right: ", ";\n\t\tpadding-left: ", ";\n\t"])), size && "font-size: " + setSize(size).iconSize + ";", label ? '0.5rem' : '0', label ? '0px' : '0');
  return (0, _core.jsx)(lseds_1.lseds.button, _extends({
    ref: ref,
    css: defaultStyle
  }, rest), icon && (0, _core.jsx)("div", {
    css: iconStyle
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: icon
  })), label);
});

if (utils_1.isDev) {
  exports.FloatingButton.displayName = 'FloatingButton';
}

var templateObject_1, templateObject_2;